import { signOut as nextAuthSignOut } from "next-auth/react";

export const REDIRECT_MESSAGES = {
  checkout: "Redirecting to secure checkout…",
  signingOut: "Signing out…",
  signingIn: "Redirecting to sign in…",
  redirecting: "Redirecting…",
  pricing: "Loading…",
} as const;

type RedirectMessage = (typeof REDIRECT_MESSAGES)[keyof typeof REDIRECT_MESSAGES] | string;

let showHandler: ((message: RedirectMessage) => void) | null = null;
let hideHandler: (() => void) | null = null;

export function registerRedirectLoadingHandlers(handlers: {
  show: (message: RedirectMessage) => void;
  hide: () => void;
}): () => void {
  showHandler = handlers.show;
  hideHandler = handlers.hide;
  return () => {
    showHandler = null;
    hideHandler = null;
  };
}

export function showRedirectLoading(
  message: RedirectMessage = REDIRECT_MESSAGES.redirecting
): void {
  showHandler?.(message);
}

export function hideRedirectLoading(): void {
  hideHandler?.();
}

/** Full-page navigation with overlay so stale UI is not visible during the handoff. */
export function redirectTo(
  url: string,
  message: RedirectMessage = REDIRECT_MESSAGES.redirecting
): void {
  showRedirectLoading(message);
  window.location.href = url;
}

/** Sign out and return to the homepage with a full-page loading overlay. */
export function signOutToHome(): void {
  showRedirectLoading(REDIRECT_MESSAGES.signingOut);
  void nextAuthSignOut({ callbackUrl: "/" });
}
